import { hrApiClient } from '@/lib/api/clients';

export interface CurrencyRateResponse {
  currency: string;
  rate: number;
}

export async function getUsdRate(): Promise<number | null> {
  try {
    const res = await hrApiClient.get('/data/currency/USD');
    if (res.data.length > 0) {
      return res.data[0].rate_float;
    }
    return null;
  } catch (error) {
    console.error('Fetch error:', error);
    return null;
  }
}
